import { useEffect, useState } from "react";
import { useWebSocketConnection } from "../../services/connectionContext/connectionContext";

export const SerialMessageList = ({ socketSerialDataEvent }) => {
    const { eventEmitter } = useWebSocketConnection();
    const [serialMsgArr, setSerialMsgArr] = useState([]);

    useEffect(() => {
        eventEmitter.on(socketSerialDataEvent, setSerialMsgArr);
        return () => {
            eventEmitter.off(socketSerialDataEvent, setSerialMsgArr);
        }
    }, [eventEmitter, socketSerialDataEvent]);

    const listItems = serialMsgArr.map((value, i) => (<li key={i}>{value}</li>));

    return (
        <>
            <ul>
                {listItems}
            </ul>
        </>
    );
}
